import {
  montarFormaPagamentoOptionFromApi,
  montarTipoPagamentoFromForma,
  enriquecerPagamentoComTipoSelect,
} from "../../utility/formaPagamentoTipo";
import { montarTaxaClienteOptionFromPagamento } from "../../utility/taxaCliente";

const PARCELA_1X = { label: "1X", value: 1 };

function montarParcelaOption(parcela) {
  if (parcela != null && parcela.par_id != null) {
    return {
      value: parcela.par_id,
      label: parcela.par_nome || "1X",
    };
  }
  if (parcela?.value != null && parcela.value !== "") {
    return {
      value: parcela.value,
      label: parcela.label || "1X",
    };
  }
  return { ...PARCELA_1X };
}

const INITIAL_STATE = {
  reserva: {
    parceiro: {},
    pagamentosAntecipado: [
      {
        tipoPagamento: null,
        formaPagamento: {
          label: "Selecione a forma de pagamento!",
          pag_credito: null,
          value: null,
        },
        comprovantesArquivos: [],
        local: "",
        parcela: { label: "Selecione o parcelamento!", value: null },
        valor: "",
        taxaCliente: null,
      },
    ],
    pagamentosEmbarque: [],
  },
  reservas: [],
  reservasOrdenada: [],
  reservasMapa: [],
  vinculosAmigos: {},
  reservasSelecionadas: [],
  activeTab: 1,
  agruparLista: false,
  reservasRepasses: [],
  reservasRepassesAgruparLista: false,
  reservasRepassesTotais: {},
  cambios: [],
  cambio: null,
  moedas: [],
  idiomas: [],
  agentes: [],
  agentesOptions: [],
  pacotes: [],
  embarques: [],
  pagamentos: [],
  parcelas: [],
  tarifa: null,
  totaisGerais: {
    adtFoot: 0,
    chdFoot: 0,
    infFoot: 0,
    jovenFoot: 0,
    idosoFoot: 0,
    totalFoot: 0,
    aReceberFoot: 0,
  },
  toogleModalMapaEmbarque: false,
  /** completo = 1ª geração (guia+apoio); titular | apoio = reedição após escolha. */
  mapaEmbarqueModo: 'completo',
  mapaEmbarqueEscolhaAberta: false,
  tiposSelect: [],
  tipo: {},
  tipos: [],
  status: [],
  modelo: {},
  reservasCheckAll: false,
  dataFiltro: {},
  pax: [
    {
      res_nome: "",
      idioma_select: { label: "Selecione um idioma!", value: "" },
      res_email: "",
      res_telefone: "",
    },
  ],
  taxa: {
    id: 0,
    valor: 0,
    cobranca: 0,
  },
  filtro: {
    valor: 0,
    status: { value: "", label: "Selecione um Status" },
    dataDe: new Date(),
    dateAte: new Date(),
    guia: { value: "", label: "Selecione o Guia" },
    tipo: { value: "", label: "Selecione o tipo de filtro" },
    agrupar: { value: "", label: "Selecione o tipo de agrupamento" },
  },

  historicos: [],
  loadingHistorico: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "RESERVAS_ERASED":
      return { ...state, reservas: action.payload };
    case "RESERVAS_STATUS_TODOS":
      return { ...state, status: action.payload };
    case "RESERVAS_FETCHED":
      // Preserva o estado grupoAberto dos grupos existentes quando novos dados são carregados
      // e reaplica o checkbox a partir de reservasSelecionadas (evita dessincronizar após filtrar)
      if (Array.isArray(action.payload)) {
        // A recarga do tempo real não limpa a seleção (quem está marcando para
        // gerar mapa perdia tudo). Só sai dela o que mudou por baixo: reserva
        // que sumiu da lista, foi cancelada ou mudou de mapa.
        const linhasDe = (lista) =>
          (Array.isArray(lista) ? lista : []).flatMap((item) =>
            item?.dados && Array.isArray(item.dados) ? item.dados : (item?.res_id != null ? [item] : [])
          )
        const mapaAntes = new Map(
          linhasDe(state.reservas).map((row) => [Number(row.res_id), row.mapa_id ?? null])
        )
        const linhaNova = new Map(linhasDe(action.payload).map((row) => [Number(row.res_id), row]))

        const selecaoAnterior = (state.reservasSelecionadas || []).map((id) => Number(id))
        const selecaoValida = selecaoAnterior.filter((id) => {
          const row = linhaNova.get(id)
          if (!row) return false
          if (Number(row?.status?.tip_id ?? row?.res_idstatus) === 4) return false
          if (mapaAntes.has(id) && Number(mapaAntes.get(id) || 0) !== Number(row.mapa_id || 0)) return false
          return true
        })
        const idsSelecionados = new Set(selecaoValida)
        // Sem aviso na tela: a recarga é silenciosa e a linha some da seleção
        // junto com a mudança que a tirou (ela já aparece desmarcada).
        const selecaoAjustada = selecaoValida.length !== selecaoAnterior.length
          ? { reservasSelecionadas: selecaoValida }
          : {}

        const aplicarSelecao = (lista) =>
          lista.map((item) => {
            if (item?.dados && Array.isArray(item.dados)) {
              return {
                ...item,
                dados: item.dados.map((row) => ({
                  ...row,
                  selecionado: idsSelecionados.has(Number(row.res_id)) ? 1 : 0
                }))
              }
            }
            if (item?.res_id != null) {
              return {
                ...item,
                selecionado: idsSelecionados.has(Number(item.res_id)) ? 1 : 0
              }
            }
            return item
          })

        if (Array.isArray(state.reservas)) {
          const novasReservas = action.payload.map((novaReserva, index) => {
            // Tenta encontrar o grupo correspondente no estado anterior
            const grupoAnterior = state.reservas.find((grupoAntigo, idxAntigo) => {
              // Compara pelo título ou índice para identificar o mesmo grupo
              return grupoAntigo.titulo === novaReserva.titulo || idxAntigo === index;
            });
            
            // Se encontrou o grupo anterior e ele estava aberto, preserva o estado
            if (grupoAnterior && grupoAnterior.grupoAberto !== undefined) {
              return {
                ...novaReserva,
                grupoAberto: grupoAnterior.grupoAberto
              };
            }
            
            // Se não encontrou, mantém o estado padrão (fechado) ou o que veio do servidor
            return {
              ...novaReserva,
              grupoAberto: novaReserva.grupoAberto !== undefined ? novaReserva.grupoAberto : false
            };
          });
          return { ...state, ...selecaoAjustada, reservas: aplicarSelecao(novasReservas) };
        }
        return { ...state, ...selecaoAjustada, reservas: aplicarSelecao(action.payload) };
      }
      return { ...state, reservas: action.payload };
    case "RESERVAS_FORMATAR_FETCHED":
      const reservasCopy = { ...action.payload.dadosFatura };

      let parseTotal = "";
      let parseDebito = "";
      let parseComissao = "";
      const reservasArray = [];

      for (const reservaCopy of reservasCopy.reservas) {
        let comissao = 0;
        let conversao = 0;

        conversao =
          Number(reservaCopy.res_total_venda) -
          Number(reservaCopy.res_total_neto);
        comissao = conversao.toFixed(2);

        parseTotal = reservaCopy.res_total_venda.toString();
        parseComissao = comissao.toString();
        parseDebito = reservaCopy.res_total_neto.toString();

        reservaCopy.res_total_venda = parseTotal.replace(".", ",");
        reservaCopy.comissao = parseComissao.replace(".", ",");
        reservaCopy.res_total_neto = parseDebito.replace(".", ",");

        reservasArray.push(reservaCopy);
      }

      return { ...state, reservas: reservasArray };
    case "RESERVA_PAGAMENTOS_ANTECIPADOS_SET": {
      const reservaPagametnosCopy = { ...state.reserva };
      reservaPagametnosCopy.pagamentosAntecipado = action.payload;
      return { ...state, reserva: reservaPagametnosCopy };
    }
    case "RESERVA_PAGAMENTOS_EMBARQUE_SET":
      const reservaEmbarqueCopy = { ...state.reserva };
      reservaEmbarqueCopy.pagamentosEmbarque = action.payload;
      return { ...state, reserva: reservaEmbarqueCopy };

    case "RESERVA_PAGAMENTOS_EMBARQUE_REMOVE":
      var reservaTCopy = { ...state.reserva };
      var reservaTPagamentosEmbarqueCopy = [...reservaTCopy.pagamentosEmbarque];
      reservaTPagamentosEmbarqueCopy.splice(action.payload, 1);
      reservaTCopy.pagamentosEmbarque = reservaTPagamentosEmbarqueCopy;
      return { ...state, reserva: reservaTCopy };
    case "RESERVAS_ABRIR_GRUPO":
      const reservas = [...state.reservas];
      const index = action.index;
      const teste = { ...reservas[index] };
      teste.grupoAberto = !teste.grupoAberto;
      reservas[index] = teste;
      return { ...state, reservas };
    case "RESERVA_REMOVER_DA_LISTA": {
      const resIdRemover = action.payload?.reservaId;
      if (resIdRemover == null) return state;
      const removerDaLista = (lista) =>
        (lista || []).flatMap((item) => {
          if (item.dados && Array.isArray(item.dados)) {
            const dados = item.dados.filter((row) => Number(row.res_id) !== Number(resIdRemover));
            if (dados.length === 0) return [];
            return [{ ...item, dados }];
          }
          return Number(item.res_id) === Number(resIdRemover) ? [] : [item];
        });
      return { ...state, reservas: removerDaLista(state.reservas) };
    }
    case "RESERVA_ATUALIZAR_STATUS_NA_LISTA":
      // Atualiza apenas o status da reserva na lista (sem recarregar), preservando grupoAberto
      const { reservaId: resIdStatus, status: novoStatus } = action.payload;
      const atualizarStatusNaLinha = (row) =>
        Number(row.res_id) === Number(resIdStatus)
          ? { ...row, status: novoStatus, res_idstatus: novoStatus?.tip_id }
          : row;
      const reservasComStatusAtualizado = state.reservas.map((item) => {
        if (item.dados && Array.isArray(item.dados)) {
          return {
            ...item,
            dados: item.dados.map(atualizarStatusNaLinha),
          };
        }
        if (Number(item.res_id) === Number(resIdStatus)) {
          return { ...item, status: novoStatus, res_idstatus: novoStatus?.tip_id };
        }
        return item;
      });
      const reservasRepassesComStatusAtualizado = Array.isArray(state.reservasRepasses)
        ? state.reservasRepasses.map((item) => {
            if (item.dados && Array.isArray(item.dados)) {
              return {
                ...item,
                dados: item.dados.map(atualizarStatusNaLinha),
              };
            }
            if (Number(item.res_id) === Number(resIdStatus)) {
              return { ...item, status: novoStatus, res_idstatus: novoStatus?.tip_id };
            }
            return item;
          })
        : state.reservasRepasses;
      return { ...state, reservas: reservasComStatusAtualizado, reservasRepasses: reservasRepassesComStatusAtualizado };
    case "RESERVA_ATUALIZAR_GUIA_NA_LISTA": {
      // Atualiza o guia nas linhas sem recarregar a lista e re-sincroniza o checkbox com o array
      const idsGuia = new Set(
        (Array.isArray(action.payload?.reservaIds) ? action.payload.reservaIds : [])
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id))
      )
      const guiaData = action.payload?.guia
      if (idsGuia.size === 0) return state

      const idsSelecionados = new Set(
        (state.reservasSelecionadas || [])
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id))
      )

      const atualizarGuiaNaLinha = (row) => {
        if (!idsGuia.has(Number(row.res_id))) {
          return {
            ...row,
            selecionado: idsSelecionados.has(Number(row.res_id)) ? 1 : 0
          }
        }

        const parId = guiaData?.par_id || null
        const pesNome = guiaData?.pes_nome || ""
        const base = {
          ...row,
          res_guia_id: parId,
          guia: parId
            ? {
                ...(row.guia || {}),
                par_id: parId,
                pessoa: {
                  ...(row.guia?.pessoa || {}),
                  pes_nome: pesNome
                }
              }
            : null
        }

        return {
          ...base,
          selecionado: idsSelecionados.has(Number(base.res_id)) ? 1 : 0
        }
      }

      const mapLista = (lista) =>
        (Array.isArray(lista) ? lista : []).map((item) => {
          if (item?.dados && Array.isArray(item.dados)) {
            return { ...item, dados: item.dados.map(atualizarGuiaNaLinha) }
          }
          return atualizarGuiaNaLinha(item)
        })

      return {
        ...state,
        reservas: mapLista(state.reservas),
        reservasRepasses: mapLista(state.reservasRepasses)
      }
    }
    case "RESERVA_ATUALIZAR_APOIO_NA_LISTA": {
      const idsApoio = new Set(
        (Array.isArray(action.payload?.reservaIds) ? action.payload.reservaIds : [])
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id))
      )
      const apoioData = action.payload?.apoio
      if (idsApoio.size === 0) return state

      const atualizarApoioNaLinha = (row) => {
        if (!idsApoio.has(Number(row.res_id))) return row

        const parId = apoioData?.par_id || null
        const pesNome = apoioData?.pes_nome || ""
        const apoioAnteriorId = row?.apoio?.par_id ?? row?.apoio_parceiro_id ?? null
        const apoioMudou = String(apoioAnteriorId ?? "") !== String(parId ?? "")

        return {
          ...row,
          apoio_parceiro_id: parId,
          // Saiu ou trocou o apoio: some do mapa de apoio até gerar de novo.
          ...(apoioMudou ? { mapa_apoio_id: null } : {}),
          apoio: parId
            ? {
                ...(row.apoio || {}),
                par_id: parId,
                pessoa: {
                  ...(row.apoio?.pessoa || {}),
                  pes_nome: pesNome
                }
              }
            : null
        }
      }

      const mapListaApoio = (lista) =>
        (Array.isArray(lista) ? lista : []).map((item) => {
          if (item?.dados && Array.isArray(item.dados)) {
            return { ...item, dados: item.dados.map(atualizarApoioNaLinha) }
          }
          return atualizarApoioNaLinha(item)
        })

      return {
        ...state,
        reservas: mapListaApoio(state.reservas),
        reservasRepasses: mapListaApoio(state.reservasRepasses),
        reservasOrdenada: mapListaApoio(state.reservasOrdenada)
      }
    }
    case "RESERVA_MARCAR_MAPA_NA_LISTA": {
      // Após Gerar mapa: atualiza mapa_id / mapa_apoio_id na lista sem reload,
      // senão a 2ª abertura não mostra a escolha titular/apoio.
      // Quem saiu da seleção perde o vínculo, senão a tabela continua
      // tratando a reserva como se ainda estivesse neste mapa.
      const idsMapa = new Set(
        (Array.isArray(action.payload?.reservaIds) ? action.payload.reservaIds : [])
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id))
      )
      const idsRemovidas = new Set(
        (Array.isArray(action.payload?.reservaIdsRemovidas) ? action.payload.reservaIdsRemovidas : [])
          .map((id) => Number(id))
          .filter((id) => Number.isFinite(id))
      )
      const mapaId = action.payload?.mapaId != null
        ? Number(action.payload.mapaId)
        : null
      const ehMapaApoio = Boolean(action.payload?.ehMapaApoio)
      const guiaId = action.payload?.guiaId ? Number(action.payload.guiaId) : null
      const guiaNome = action.payload?.guiaNome || null
      if (idsMapa.size === 0 && idsRemovidas.size === 0) return state

      // `mapa` completo (com guia.pessoa) de linhas que já vieram do servidor,
      // desde que seja do mesmo guia — se o guia do mapa mudou no modal, o
      // objeto antigo está defasado e vale o montado com o guia novo.
      const mapaPorId = new Map()
      ;[state.reservas, state.reservasRepasses, state.reservasOrdenada].forEach((lista) => {
        (Array.isArray(lista) ? lista : []).forEach((item) => {
          const rows = item?.dados && Array.isArray(item.dados) ? item.dados : [item]
          rows.forEach((row) => {
            const m = row?.mapa
            const id = Number(row?.mapa_id)
            const guiaDoObjeto = Number(m?.guia?.par_id ?? m?.map_guia_id)
            if (!m || !id || mapaPorId.has(id)) return
            if (guiaId && guiaDoObjeto !== guiaId) return
            mapaPorId.set(id, m)
          })
        })
      })

      const saiuDesteMapa = (row) => {
        const id = Number(row.res_id)
        if (idsMapa.has(id)) return false
        if (idsRemovidas.has(id)) return true
        if (!mapaId) return false
        if (ehMapaApoio) return Number(row.mapa_apoio_id) === mapaId
        return Number(row.mapa_id) === mapaId
      }

      const marcarMapaNaLinha = (row) => {
        if (saiuDesteMapa(row)) {
          if (ehMapaApoio) {
            return { ...row, mapa_apoio_id: null }
          }
          return {
            ...row,
            mapa_id: null,
            mapa: null,
            mapa_embarque_reserva: null,
            mapaEmbarqueReserva: null
          }
        }
        if (!idsMapa.has(Number(row.res_id))) return row
        if (ehMapaApoio) {
          return {
            ...row,
            // Placeholder truthy se a API não devolver o id — só precisa
            // existir para selecaoJaTemMapa.
            mapa_apoio_id: mapaId || row.mapa_apoio_id || 1
          }
        }
        const mapaIdFinal = mapaId || row.mapa_id || 1
        // A linha também precisa do `mapa` (com o guia): é por ele que a
        // seleção decide quem é do mesmo guia. Reaproveita o de uma linha que
        // já veio do servidor neste mapa; senão monta com o guia do modal.
        const mapaDaLinha = (mapaId && mapaPorId.get(mapaId))
          || (mapaId && guiaId
            ? {
              ...(row.mapa || {}),
              map_id: mapaId,
              map_guia_id: guiaId,
              guia: { par_id: guiaId, pessoa: { pes_nome: guiaNome } }
            }
            : row.mapa)
        return {
          ...row,
          mapa_id: mapaIdFinal,
          mapa: mapaDaLinha,
          res_guia_id: guiaId || row.res_guia_id
        }
      }

      const mapListaMapa = (lista) =>
        (Array.isArray(lista) ? lista : []).map((item) => {
          if (item?.dados && Array.isArray(item.dados)) {
            return { ...item, dados: item.dados.map(marcarMapaNaLinha) }
          }
          return marcarMapaNaLinha(item)
        })

      return {
        ...state,
        reservas: mapListaMapa(state.reservas),
        reservasRepasses: mapListaMapa(state.reservasRepasses),
        reservasOrdenada: mapListaMapa(state.reservasOrdenada)
      }
    }
    case "LIMPAR_RESERVAS_SELECIONADAS":
      return { ...state, reservasSelecionadas: [], reservasCheckAll: false, reservasOrdenada: [] };
    case "LIMPAR_RESERVAS_ORDENADA":
      return { ...state, reservasOrdenada: [] };
    case "RESERVAS_VINCULAR_AMIGOS": {
      const { principalId, vinculadosIds } = action.payload || {};
      if (!principalId || !Array.isArray(vinculadosIds) || vinculadosIds.length === 0) return state;
      const novosVinculos = { ...state.vinculosAmigos };
      vinculadosIds.forEach((id) => {
        if (id !== principalId) novosVinculos[id] = principalId;
      });
      return { ...state, vinculosAmigos: novosVinculos };
    }
    case "RESERVAS_VINCULOS_AMIGOS_MERGE": {
      if (!action.payload || typeof action.payload !== "object") return state;
      return {
        ...state,
        vinculosAmigos: { ...state.vinculosAmigos, ...action.payload },
      };
    }
    case "RESERVAS_VINCULOS_AMIGOS_REMOVE_IDS": {
      const idsLimpos = Array.isArray(action.payload) ? action.payload : [];
      if (idsLimpos.length === 0) return state;
      const mapa = { ...state.vinculosAmigos };
      idsLimpos.forEach((id) => {
        delete mapa[String(id)];
      });
      Object.keys(mapa).forEach((amigoId) => {
        if (idsLimpos.includes(Number(mapa[amigoId]))) {
          delete mapa[amigoId];
        }
      });
      return { ...state, vinculosAmigos: mapa };
    }
    case "LIMPAR_RESERVAS_SELECIONADAS_E_CHECKBOX":
      // Limpa reservas selecionadas, checkbox e estado selecionado das reservas
      const reservasLimpas = state.reservas.map(reserva => {
        // Se for um grupo (tem dados), limpa os dados também
        if (reserva.dados && Array.isArray(reserva.dados)) {
          return {
            ...reserva,
            dados: reserva.dados.map(dado => ({ ...dado, selecionado: 0 }))
          }
        }
        // Se for reserva individual
        return { ...reserva, selecionado: 0 }
      })
      // Limpa também as reservas repassadas
      const reservasRepassesLimpas = state.reservasRepasses.map(reserva => ({
        ...reserva,
        selecionado: 0
      }))
      return { 
        ...state, 
        reservasSelecionadas: [], 
        reservasCheckAll: false,
        reservas: reservasLimpas,
        reservasRepasses: reservasRepassesLimpas,
        reservasOrdenada: []
      };
    case "SELECIONAR_RESERVA": {
      const id = Number(action.payload)
      if (!Number.isFinite(id)) return state

      const jaSelecionada = (state.reservasSelecionadas || []).some((x) => Number(x) === id)
      const novasReservasSelecionadas = jaSelecionada
        ? (state.reservasSelecionadas || []).filter((x) => Number(x) !== id)
        : [...(state.reservasSelecionadas || []), id]

      const idsSet = new Set(novasReservasSelecionadas.map((x) => Number(x)))
      const aplicarSelecaoLocal = (lista) =>
        (Array.isArray(lista) ? lista : []).map((item) => {
          if (item?.dados && Array.isArray(item.dados)) {
            return {
              ...item,
              dados: item.dados.map((row) => ({
                ...row,
                selecionado: idsSet.has(Number(row.res_id)) ? 1 : 0
              }))
            }
          }
          if (item?.res_id != null) {
            return {
              ...item,
              selecionado: idsSet.has(Number(item.res_id)) ? 1 : 0
            }
          }
          return item
        })

      return {
        ...state,
        reservasSelecionadas: novasReservasSelecionadas,
        reservas: aplicarSelecaoLocal(state.reservas),
        reservasRepasses: aplicarSelecaoLocal(state.reservasRepasses)
      }
    }
    case "SELECIONAR_RESERVAS_SET": {
      // Define explicitamente o conjunto de IDs selecionados (sem toggle)
      const novasReservasSelecionadas = (Array.isArray(action.payload) ? action.payload : [])
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id))
      const idsSet = new Set(novasReservasSelecionadas)
      const aplicarSelecaoLocal = (lista) =>
        (Array.isArray(lista) ? lista : []).map((item) => {
          if (item?.dados && Array.isArray(item.dados)) {
            return {
              ...item,
              dados: item.dados.map((row) => ({
                ...row,
                selecionado: idsSet.has(Number(row.res_id)) ? 1 : 0
              }))
            }
          }
          if (item?.res_id != null) {
            return {
              ...item,
              selecionado: idsSet.has(Number(item.res_id)) ? 1 : 0
            }
          }
          return item
        })

      return {
        ...state,
        reservasSelecionadas: novasReservasSelecionadas,
        reservasCheckAll: false,
        reservas: aplicarSelecaoLocal(state.reservas),
        reservasRepasses: aplicarSelecaoLocal(state.reservasRepasses)
      }
    }
    case "HANDLE_LISTA_AGRUPAR":
      return { ...state, agruparLista: action.payload };
    case "RESERVA_TOGLE_MODAL_MAPA_EMBARQUE":
      return {
        ...state,
        toogleModalMapaEmbarque: !state.toogleModalMapaEmbarque,
        ...(!state.toogleModalMapaEmbarque
          ? {}
          : { mapaEmbarqueModo: 'completo', mapaEmbarqueEscolhaAberta: false }),
      };
    case "SET_MAPA_EMBARQUE_MODO":
      return {
        ...state,
        mapaEmbarqueModo: action.payload || 'completo',
      };
    case "SET_MAPA_EMBARQUE_ESCOLHA_ABERTA":
      return {
        ...state,
        mapaEmbarqueEscolhaAberta: Boolean(action.payload),
      };
    case "RESERVAS_REPASSE_FETCHED": {
      const isObject = action.payload && typeof action.payload === 'object' && !Array.isArray(action.payload);
      const reservas = isObject ? action.payload.reservas : action.payload;
      const agrupar = isObject ? (action.payload.agruparLista === true) : false;
      const totais = isObject && action.payload.adtFoot !== undefined ? {
        adtFoot: action.payload.adtFoot,
        chdFoot: action.payload.chdFoot,
        infFoot: action.payload.infFoot,
        jovenFoot: action.payload.jovenFoot,
        idosoFoot: action.payload.idosoFoot,
        totalFoot: action.payload.totalFoot,
        aReceberFoot: action.payload.aReceberFoot,
      } : {};
      return {
        ...state,
        reservasRepasses: Array.isArray(reservas) ? reservas : [],
        reservasRepassesAgruparLista: agrupar,
        reservasRepassesTotais: totais,
      };
    }
    case "RESERVAS_REPASSE_ABRIR_GRUPO": {
      const list = [...(state.reservasRepasses || [])];
      const idx = action.index;
      if (list[idx]) {
        list[idx] = { ...list[idx], grupoAberto: !list[idx].grupoAberto };
      }
      return { ...state, reservasRepasses: list };
    }
    case "RESERVAS_REPASSE_UPDATE_LISTA":
      return { ...state, reservasRepasses: action.payload || [] };
    case "RESERVA_SET": {
      const reserva = { ...action.payload };
      if (reserva && !reserva.pagamentosAntecipado) {
        reserva.pagamentosAntecipado = [];
      }

      if (
        reserva.pagamentosAntecipado.length <= 0 &&
        reserva.pagamentos &&
        reserva.pagamentos.length > 0
      ) {
        for (const pagamentos of reserva.pagamentos) {
          const forma = pagamentos?.forma;
          const tipoDaForma =
            forma?.pag_idtipo != null
              ? {
                value: forma.pag_idtipo,
                label: forma?.tipo?.nome || "",
              }
              : null;
          reserva.pagamentosAntecipado.push({
            tipoPagamento: tipoDaForma,
            banco:
              pagamentos?.banco !== null
                ? {
                  label: pagamentos.banco.ban_nome,
                  value: pagamentos.pag_idbanco,
                }
                : { label: "Selecione o banco!", value: null },
            valor: pagamentos?.pag_valor,
            formaPagamento:
              forma !== null
                ? {
                  label: forma?.pag_nome,
                  value: forma?.pag_id,
                  pag_credito: forma?.pag_credito,
                  pag_idtipo: forma?.pag_idtipo ?? null,
                  tipo_nome: forma?.tipo?.nome ?? null,
                  pag_fornecedor_id: forma?.pag_fornecedor_id ?? forma?.fornecedor?.par_id ?? null,
                  pag_fornecedor_nome: forma?.fornecedor?.pessoa?.pes_nome ?? null,
                }
                : {
                  label: "Selecione a forma de pagamento!",
                  pag_credito: null,
                  value: null,
                  pag_idtipo: null,
                },
            motivoCortesia: pagamentos?.motivo_cortesia
              ? {
                value: pagamentos.motivo_cortesia.id,
                label: pagamentos.motivo_cortesia.nome,
              }
              : null,
            cortesiaResponsavel: pagamentos?.cortesia_responsavel
              ? {
                value: pagamentos.cortesia_responsavel,
                label: pagamentos.cortesia_responsavel,
              }
              : null,
            fontePagamento:
              pagamentos?.fonte !== null
                ? {
                  label: pagamentos?.fonte?.nome,
                  value: pagamentos?.fonte?.id,
                }
                : { label: "Selecione a fonte de pagamento!", value: null },
            parcela: montarParcelaOption(pagamentos.parcela),
            comprovantesArquivos: (pagamentos?.comprovantes || []).map((comp) => ({
              id: comp?.id ?? null,
              isExisting: true,
              name: (comp?.arquivo || "").split("/").pop(),
              url: `${process.env.REACT_APP_BACKEND_WEB}storage/${comp?.arquivo || ""}`,
              type: ((comp?.arquivo || "").toLowerCase().endsWith(".pdf")) ? "application/pdf" : "image/*",
              conferido: Boolean(comp?.conferido),
              dataConferencia: comp?.data_conferencia ?? null,
              // Devolvida ao salvar para o comprovante recriado manter a data de inserção original.
              dataAdicionado: comp?.data_adicionado ?? null,
            })),
            local: pagamentos?.pag_local,
            taxaCliente: montarTaxaClienteOptionFromPagamento(pagamentos),
            taxa_cliente_snapshot: pagamentos?.taxa_cliente_snapshot || pagamentos?.taxaClienteSnapshot || null,
          });
        }
      }
      if (!reserva.pagamentosEmbarque) reserva.pagamentosEmbarque = [];

      if (
        reserva.pagamentosEmbarque.length <= 0 &&
        reserva.acerto_reserva &&
        reserva.acerto_reserva.acerto_reserva_pagamentos &&
        reserva.acerto_reserva.acerto_reserva_pagamentos.length > 0
      ) {
        for (const pagamento of reserva.acerto_reserva
          .acerto_reserva_pagamentos) {
          reserva.pagamentosEmbarque.push({
            banco:
              pagamento?.banco !== null
                ? {
                  label: pagamento.banco.ban_nome,
                  value: pagamento.pag_idbanco,
                }
                : { label: "Selecione o banco!", value: null },
            valor: pagamento?.valor > 0 ? pagamento?.valor : 0,
            formaPagamento: montarFormaPagamentoOptionFromApi(
              pagamento?.forma,
              pagamento?.forma?.pag_id
            ),
            tipoPagamento: montarTipoPagamentoFromForma({
              pag_idtipo: pagamento?.forma?.pag_idtipo,
              tipo_nome: pagamento?.forma?.tipo?.nome,
              tipo: pagamento?.forma?.tipo,
            }),
            // fontePagamento: { label: pagamento?.fonte?.nome, value: pagamento?.fonte?.id },
            parcela: montarParcelaOption(pagamento.parcela),
            comprovantesArquivos: [],
            local: pagamento?.pag_local ? pagamento?.pag_local : null,
            motivoCortesia: pagamento?.motivo_cortesia_id
              ? {
                value: pagamento.motivo_cortesia_id,
                label: pagamento?.motivo_cortesia?.nome ?? "",
              }
              : null,
            cortesiaResponsavel: pagamento?.cortesia_responsavel
              ? {
                value: pagamento.cortesia_responsavel,
                label: pagamento.cortesia_responsavel,
              }
              : null,
            taxaCliente: montarTaxaClienteOptionFromPagamento(pagamento),
            taxa_cliente_snapshot: pagamento?.taxa_cliente_snapshot || pagamento?.taxaClienteSnapshot || null,
            guia_embarque: pagamento?.guia_embarque || null,
          });
        }
      }

      // Já veio montado (ex.: acerto financeiro) — garante tipo/nome no select.
      if (Array.isArray(reserva.pagamentosAntecipado) && reserva.pagamentosAntecipado.length > 0) {
        reserva.pagamentosAntecipado = reserva.pagamentosAntecipado.map(
          enriquecerPagamentoComTipoSelect
        );
      }
      if (Array.isArray(reserva.pagamentosEmbarque) && reserva.pagamentosEmbarque.length > 0) {
        reserva.pagamentosEmbarque = reserva.pagamentosEmbarque.map(
          enriquecerPagamentoComTipoSelect
        );
      }

      // 3) **novo** – coloca no reserva um array camelCase para facilitar no front
      reserva.valoresTaxas = (action.payload.valores_taxas || action.payload.valoresTaxas || []).map((v) => ({
        rtaId: v.rta_id,
        taxaEntradaId: v.rta_id_taxas_entradas,
        valor: v.rta_valor,
        tax_aplica_adt: v.taxa_entrada?.tax_aplica_adt ?? v.taxaEntrada?.tax_aplica_adt,
        tax_aplica_chd: v.taxa_entrada?.tax_aplica_chd ?? v.taxaEntrada?.tax_aplica_chd,
        tax_aplica_inf: v.taxa_entrada?.tax_aplica_inf ?? v.taxaEntrada?.tax_aplica_inf,
        tax_aplica_jvm: v.taxa_entrada?.tax_aplica_jvm ?? v.taxaEntrada?.tax_aplica_jvm,
        tax_aplica_ids: v.taxa_entrada?.tax_aplica_ids ?? v.taxaEntrada?.tax_aplica_ids,
        taxaEntrada: v.taxa_entrada || v.taxaEntrada || null,
      }));

      const produtosBrutos = action.payload.produtos_vendidos || action.payload.produtosVendidos || [];
      reserva.produtosVendidos = (Array.isArray(produtosBrutos) ? produtosBrutos : []).map((item) => ({
        produtoVendaId: item.produto_venda_id ?? item.produtoVendaId,
        quantidade: item.quantidade,
        valor: item.valor,
        nome: item.produto_venda?.nome || item.produtoVenda?.nome || '',
        imagem: item.produto_venda?.imagem || item.produtoVenda?.imagem || '',
      }));

      // Desconto agora vem de reserva_valores (apenas 1 desconto)
      if (action.payload.reservaValores?.desconto_reserva_id) {
        reserva.valoresDescontos = [{
          descontoReservaId: action.payload.reservaValores.desconto_reserva_id,
          valor: action.payload.reservaValores.desconto_valor,
          tipo: action.payload.reservaValores.desconto_tipo,
        }];
      } else {
        reserva.valoresDescontos = [];
      }

      let paxCopy = [];

      if (reserva.responsavel) {
        if (reserva.responsavel.length > 0) {
          for (const responsaveis of reserva.responsavel) {
            if (responsaveis.idioma_select) {
              paxCopy.push({
                res_nome: responsaveis.res_nome,
                idioma_select: {
                  label:
                    responsaveis.idioma_select != null
                      ? responsaveis.idioma_select
                        ? responsaveis.idioma_select.label
                        : responsaveis.idioma.idi_nome
                      : null,
                  value:
                    responsaveis.idioma_select != null
                      ? responsaveis.idioma_select
                        ? responsaveis.idioma_select.value
                        : responsaveis.idioma.idi_id
                      : null,
                },
                res_email: responsaveis.res_email,
                res_telefone: responsaveis.res_telefone,
              });
            } else {
              paxCopy.push({
                res_nome: responsaveis.res_nome,
                idioma_select: {
                  label: responsaveis.idioma
                    ? responsaveis.idioma.idi_nome
                    : "Selecione um idioma!",
                  value: responsaveis.idioma ? responsaveis.idioma.idi_id : "",
                },
                res_email: responsaveis.res_email,
                res_telefone: responsaveis.res_telefone,
              });
            }
          }
        }
      } else {
        paxCopy.push({
          res_nome: "",
          idioma_select: { label: "Selecione um idioma!", value: "" },
          res_email: "",
          res_telefone: "",
        });
      }

      return { ...state, reserva, pax: paxCopy };
    }
    case "RESERVA_ATUALIZAR_CAMPO":
      var editarCopy = { ...state.reserva };
      editarCopy[action.campo] = action.valor;
      return { ...state, reserva: editarCopy };
    case "FETCHED_MODELO_ONE":
      return { ...state, modelo: action.payload };
    case "FETCHED_TIPO_ONE":
      return { ...state, tipo: action.payload };
    case "TIPOS_FETCHED":
      return { ...state, tipos: action.payload };
    case "TIPOS_SELECT_FETCHED":
      return { ...state, tiposSelect: action.payload };
    case "IDIOMAS_FETCHED":
      return { ...state, idiomas: action.payload };
    case "PACOTE_FETCHED":
      return { ...state, pacotes: action.payload };
    case "EMBARQUE_FETCHED":
      return { ...state, embarques: action.payload };
    case "AGENTE_FETCHED":
      const copyAgentes = [];

      for (const agente of action.payload.agentes) {
        const nome = agente.pes_nome || agente.pessoa?.pes_nome || '';
        const cpf = agente.fis_cpf || agente.pessoa?.fisica?.fis_cpf || '';
        const label = cpf ? `${nome} - ${cpf}` : nome;
        
        copyAgentes.push({
          value: agente.usu_id,
          label: label,
        });
      }

      return { ...state, agentes: action.payload, agentesOptions: copyAgentes };
    case "FORMA_PAGAMENTO_FETCHED":
      return { ...state, pagamentos: action.payload };
    case "PARCELA_FETCHED":
      return { ...state, parcelas: action.payload };
    case "TARIFA_FETCHED":
      return { ...state, tarifa: action.payload };
    case "CAMBIO_FETCHED":
      return { ...state, cambios: action.payload };
    case "CAMBIO_MOEDAS_FETCHED":
      return { ...state, moedas: action.payload };
    case "RESERVA_ACTIVE_TAB":
      return { ...state, activeTab: action.payload };
    case "RESERVAS_TOTAIS_GERAIS":
      const totaisGerais = {
        adtFoot: action.payload.adtFoot,
        chdFoot: action.payload.chdFoot,
        infFoot: action.payload.infFoot,
        jovenFoot: action.payload.jovenFoot,
        idosoFoot: action.payload.idosoFoot,
        totalFoot: action.payload.totalFoot,
        aReceberFoot: action.payload.aReceberFoot,
        totalDebito: action.payload.totalDebito,
      };
      return { ...state, totaisGerais };
    case "RESERVA_CHECK_ALL":
      return { ...state, reservasCheckAll: !state.reservasCheckAll };
    case "RESERVA_CHECK_ALL_MANUAL":
      return { ...state, reservasCheckAll: action.payload };
    // case 'RESERVA_CHECK': {
    //     const allCheck = state.reservasCheckAll
    //     const copyReservas = [...state.reservas]
    //     const reservaCopy = { ...copyReservas[action.index] }
    //     reservaCopy.selecionado = reservaCopy.selecionado ? 0 : 1
    //     console.log(reservaCopy.selecionado, 'RESERVA_CHECK')
    //     copyReservas[action.index] = reservaCopy

    //     return { ...state, reservas: copyReservas }
    // }
    case "RESERVA_CHECK": {
      const allCheck = state.reservasCheckAll;
      const copyReservas = state.reservas.map((reserva) => ({
        ...reserva,
        selecionado: allCheck ? 1 : 0,
      }));

      return { ...state, reservas: copyReservas };
    }

    case "RESERVA_REPASSE_CHECK":
      const copyReservasRepasse = [...state.reservasRepasses];
      const reservaCopyRepasse = { ...copyReservasRepasse[action.index] };
      reservaCopyRepasse.selecionado = reservaCopyRepasse.selecionado ? 0 : 1;

      copyReservasRepasse[action.index] = reservaCopyRepasse;

      return { ...state, reservasRepasses: copyReservasRepasse };
    case "RESERVA_PAGAMENTO_EMBARQUE_CHANGE": {
      var copyReserva = { ...state.reserva };
      const copyPagamentosEmbarque = [...state.reserva.pagamentosEmbarque];
      var rowCopy = { ...copyPagamentosEmbarque[action.index] };
      rowCopy[action.campoChange] = action.payload;
      if (action.campoChange === "taxaCliente") {
        rowCopy.taxa_cliente_snapshot = null;
        rowCopy.taxaClienteSnapshot = null;
      }
      if (action.campoChange === "formaPagamento") {
        if (action.tipoPagamentoExplicit !== undefined) {
          rowCopy.tipoPagamento = action.tipoPagamentoExplicit;
        } else if (
          action.payload?.value == null ||
          action.payload?.value === "" ||
          action.payload?.value === undefined
        ) {
          if (action.payload?.pag_idtipo) {
            rowCopy.tipoPagamento = {
              value: action.payload.pag_idtipo,
              label: action.payload.tipo_nome || action.payload.label || "",
            };
          } else {
            rowCopy.tipoPagamento = null;
          }
        } else if (action.payload?.pag_idtipo) {
          rowCopy.tipoPagamento = {
            value: action.payload.pag_idtipo,
            label: action.payload.tipo_nome || action.payload.label || "",
          };
        }
      }

      copyPagamentosEmbarque[action.index] = rowCopy;
      copyReserva.pagamentosEmbarque = copyPagamentosEmbarque;
      var soma = 0;
      for (const pagamento of copyReserva.pagamentosEmbarque) {
        if (isNaN(pagamento.valor)) {
          var valor = Number(pagamento?.valor.replace(",", "."));
        } else {
          valor = pagamento?.valor;
        }
        soma = soma + valor;
      }
      copyReserva.totalpago = soma;
      return { ...state, reserva: copyReserva };
    }
    case "RESERVAS_DATA_FILTRO":
      return { ...state, dataFiltro: action.payload };
    case "RESERVAS_FILTRO_INPUT": {
      const copyFiltro = { ...state.filtro };

      copyFiltro[action.input] = action.payload;

      return { ...state, filtro: copyFiltro };
    }
    case "RESERVAS_FILTRO_ERASED": {
      const copyFiltro = {
        valor: 0,
        status: { value: "", label: "Selecione um Status" },
        dataDe: new Date(),
        dateAte: new Date(),
        guia: { value: "", label: "Selecione o Guia" },
        tipo: { value: "", label: "Selecione o tipo de filtro" },
        agrupar: { value: "", label: "Selecione o tipo de agrupamento" },
      };

      return { ...state, filtro: copyFiltro };
    }
    case "RESERVA_REMOVER_LINHA_PAGAMENTOS_ANTECIPADOS":
      var novosPagamentos = state.reserva.pagamentosAntecipado.filter(
        (pagamento, index) => index !== action.index
      );
      return {
        ...state,
        reserva: { ...state.reserva, pagamentosAntecipado: novosPagamentos },
      };
    case "RESERVA_PAGAMENTO_CHANGE_PAGAMENTOS_ANTECIPADOS": {
      var pagamentosCopy = [...state.reserva.pagamentosAntecipado];
      var reservaCopy = { ...state.reserva };
      const newformaPagamento = { ...pagamentosCopy[action.index] };

      if (action.payload.value == 4) {
        newformaPagamento.formaPagamento = action.payload;
      } else {
        newformaPagamento.formaPagamento = action.payload;
        newformaPagamento.banco = null;
      }
      if (action.tipoPagamentoExplicit !== undefined) {
        newformaPagamento.tipoPagamento = action.tipoPagamentoExplicit;
      } else if (
        action.payload?.value == null ||
        action.payload?.value === "" ||
        action.payload?.value === undefined
      ) {
        if (action.payload?.pag_idtipo) {
          newformaPagamento.tipoPagamento = {
            value: action.payload.pag_idtipo,
            label: action.payload.tipo_nome || action.payload.label || "",
          };
        } else {
          newformaPagamento.tipoPagamento = null;
        }
      } else if (action.payload?.pag_idtipo) {
        newformaPagamento.tipoPagamento = {
          value: action.payload.pag_idtipo,
          label: action.payload.tipo_nome || action.payload.label || "",
        };
      }

      pagamentosCopy[action.index] = newformaPagamento;
      reservaCopy.pagamentosAntecipado = pagamentosCopy;
      return { ...state, reserva: reservaCopy };
    }
    case "RESERVA_PAGAMENTO_ANTECIPADO_CHANGE": {
      var reservaCopy = { ...state.reserva };
      var pagamentosCopy = [...state.reserva.pagamentosAntecipado];
      var rowCopy = { ...pagamentosCopy[action.index] };
      rowCopy[action.campoChange] = action.payload;
      if (action.campoChange == "taxaCliente") {
        rowCopy.taxa_cliente_snapshot = null;
        rowCopy.taxaClienteSnapshot = null;
      }
      if (action.campoChange == "formaPagamento") {
        if (!rowCopy.parcela?.value) {
          rowCopy.parcela = { ...PARCELA_1X };
        }
        if (
          rowCopy.formaPagamento &&
          rowCopy.formaPagamento.pag_credito == "SIM"
        ) {
          rowCopy.parcela = { ...PARCELA_1X };
        }
        if (action.tipoPagamentoExplicit !== undefined) {
          rowCopy.tipoPagamento = action.tipoPagamentoExplicit;
        } else if (
          action.payload?.value == null ||
          action.payload?.value === "" ||
          action.payload?.value === undefined
        ) {
          // Placeholder ao trocar só o tipo: mantém pag_idtipo / tipo_nome.
          if (action.payload?.pag_idtipo) {
            rowCopy.tipoPagamento = {
              value: action.payload.pag_idtipo,
              label: action.payload.tipo_nome || action.payload.label || "",
            };
          } else {
            rowCopy.tipoPagamento = null;
          }
        } else if (action.payload?.pag_idtipo) {
          rowCopy.tipoPagamento = {
            value: action.payload.pag_idtipo,
            label: action.payload.tipo_nome || action.payload.label || "",
          };
        }
      }

      pagamentosCopy[action.index] = rowCopy;
      reservaCopy.pagamentosAntecipado = pagamentosCopy;

      return { ...state, reserva: reservaCopy };
    }
    case "RESERVA_PAGAMENTO_ANTECIPADO_CHANGE_VALOR":
      var copyReserva = [...state.reserva.pagamentosAntecipado];
      var newValor = { ...copyReserva[action.index] };
      newValor.valor = action.payload;
      copyReserva[action.index] = newValor;
      return {
        ...state,
        reserva: { ...state.reserva, pagamentosAntecipado: copyReserva },
      };
    case "RESERVA_PAGAMENTO_CHANGE_FONTE_PAGAMENTOS": {
      var copyReserva = [...state.reserva.pagamentosAntecipado];
      var newFonte = { ...copyReserva[action.index] };
      newFonte.fontePagamento = action.payload;
      copyReserva[action.index] = newFonte;
      return {
        ...state,
        reserva: { ...state.reserva, pagamentosAntecipado: copyReserva },
      };
    }
    case "RESERVA_PAGAMENTO_EMBARQUE_CHANGE_FONTE_PAGAMENTOS": {
      var copyReserva = [...state.reserva.pagamentosEmbarque];
      var newFonte = { ...copyReserva[action.index] };
      newFonte.fontePagamento = action.payload;
      copyReserva[action.index] = newFonte;
      return {
        ...state,
        reserva: { ...state.reserva, pagamentosEmbarque: copyReserva },
      };
    }
    case "RESERVA_PAGAMENTO_ANTECIPADO_CHANGE_PARCELA":
      var copyReserva = [...state.reserva.pagamentosAntecipado];
      var newParcela = { ...copyReserva[action.index] };
      newParcela.parcela = action.payload;
      copyReserva[action.index] = newParcela;
      return {
        ...state,
        reserva: { ...state.reserva, pagamentosAntecipado: copyReserva },
      };
    case "RESERVA_PAGAMENTO_EMBARQUE_CHANGE_PARCELA":
      var copyReserva = [...state.reserva.pagamentosEmbarque];
      var newParcela = { ...copyReserva[action.index] };
      newParcela.parcela = action.payload;
      copyReserva[action.index] = newParcela;
      return {
        ...state,
        reserva: { ...state.reserva, pagamentosEmbarque: copyReserva },
      };
    case "RESERVA_PAGAMENTO_EMBARQUE_CHANGE_BANCO":
      var copyReserva = [...state.reserva.pagamentosEmbarque];
      var newBanco = { ...copyReserva[action.index] };
      newBanco.banco = action.payload;
      copyReserva[action.index] = newBanco;
      return {
        ...state,
        reserva: { ...state.reserva, pagamentosEmbarque: copyReserva },
      };
    case "RESERVA_PAGAMENTO_ANTECIPADO_CHANGE_BANCO":
      var copyReserva = [...state.reserva.pagamentosAntecipado];
      var newBanco = { ...copyReserva[action.index] };
      newBanco.banco = action.payload;
      copyReserva[action.index] = newBanco;
      return {
        ...state,
        reserva: { ...state.reserva, pagamentosAntecipado: copyReserva },
      };
    case "RESERVA_PAGAMENTO_ANTECIPADO_ATUALIZAR":
      const pagamentosDoBackEnd = action.payload;
      var reservaPagCopy = { ...state.reserva };
      var pagamentoCopy = [...state.reserva.pagamentosAntecipado];
      var novosPagamentos = pagamentosDoBackEnd.map((pagamento) => {
        const formaBe = pagamento.forma;
        const tipoDaForma =
          formaBe?.pag_idtipo != null
            ? {
              value: formaBe.pag_idtipo,
              label: formaBe?.tipo?.nome || "",
            }
            : null;
        return {
          // banco: { label: pagamento.banco.ban_nome, value: pagamento.banco.ban_id },
          banco:
            pagamento.banco !== null
              ? {
                label: pagamento.banco.ban_nome,
                value: pagamento.pag_idbanco,
              }
              : { label: "Selecione o banco!", value: null },
          valor: pagamento.pag_valor,
          tipoPagamento: tipoDaForma,
          formaPagamento: {
            label: formaBe.pag_nome,
            pag_credito: formaBe.pag_credito,
            value: formaBe.pag_id,
            pag_idtipo: formaBe?.pag_idtipo ?? null,
          },
          parcela:
            pagamento.parcela !== null
              ? {
                value: pagamento?.parcela?.par_id,
                label: pagamento?.parcela?.par_nome,
              }
              : { label: "1X", value: 1 },
          comprovantesArquivos: [],
          local: pagamento.pag_local,
        };
      });
      pagamentoCopy = novosPagamentos;
      reservaPagCopy.pagamentosAntecipado = pagamentoCopy;
      return { ...state, reserva: reservaPagCopy };
    case "ACERTO_FINANCEIRO_PAGAMENTO_TOTAL_RECEBER":
      var pagamentos = state.reserva.pagamentosEmbarque;
      var totalPagamentos = pagamentos.reduce((acc, pagamento) => {
        return acc + parseFloat(pagamento.valor);
      }, 0);

      var soma = totalPagamentos - action.valorNet;
      if (soma.toString().replace("-", "") > 0) {
        var novoPagamento = {
          valor: soma.toString().replace("-", ""),
          fontePagamento: {
            label: "Selecione a fonte de pagamento!",
            value: null,
          },
          formaPagamento: {
            label: "Selecione a forma de pagamento!",
            pag_credito: "",
            value: null,
          },
          parcela: { label: "1X", value: 1 },
          local: "",
        };
        var reservaPagCopy = { ...state.reserva }; // Copia a reserva
        reservaPagCopy.pagamentosEmbarque = [...pagamentos, novoPagamento]; // Adiciona o novo pagamento
        return { ...state, reserva: reservaPagCopy };
      } else {
        return { ...state, pagamentos };
      }
    case "RESERVA_VALOR_PENDENTE_PAGAMENTO": {
      var reservaCopy = { ...action.payload };
      var soma = 0;
      for (const pagamento of reservaCopy.pagamentosEmbarque) {
        if (isNaN(pagamento.valor)) {
          var valor = Number(pagamento?.valor.replace(",", "."));
        } else {
          valor = Number(pagamento?.valor);
        }
        soma = soma + valor;
      }
      reservaCopy.totalpago = soma;
      if (reservaCopy.totalpago < reservaCopy.credito_valor_net) {
        var novoPagamento = {
          valor: reservaCopy.credito_valor_net - reservaCopy.totalpago,
          fontePagamento: {
            label: "Selecione a fonte de pagamento!",
            value: null,
          },
          formaPagamento: {
            label: "Selecione a forma de pagamento!",
            pag_credito: "",
            value: null,
          },
          banco: { label: "Selecione o banco!", value: null },
          parcela: { label: "1X", value: 1 },
          local: "",
          taxaCliente: null,
        };

        reservaCopy.pagamentosEmbarque = [
          ...reservaCopy.pagamentosEmbarque,
          novoPagamento,
        ]; // Adiciona o novo pagamento
      } else if (
        reservaCopy.totalpago >= reservaCopy.credito_valor_net &&
        action.novoCampo
      ) {
        var novoPagamento = {
          valor: "",
          fontePagamento: {
            label: "Selecione a fonte de pagamento!",
            value: null,
          },
          formaPagamento: {
            label: "Selecione a forma de pagamento!",
            pag_credito: "",
            value: null,
          },
          banco: { label: "Selecione o banco!", value: null },
          parcela: { label: "1X", value: 1 },
          local: "",
          taxaCliente: null,
        };
        reservaCopy.pagamentosEmbarque = [
          ...reservaCopy.pagamentosEmbarque,
          novoPagamento,
        ]; // Adiciona o novo pagamento
      }

      return { ...state, reserva: reservaCopy };
    }
    case "RESERVAS_PAX_SET": {
      let paxCopy = { ...state.pax };
      paxCopy = action.payload;
      return { ...state, pax: paxCopy };
    }
    case "RESERVAS_REMOVER_LINHA": {
      var paxCopy = state.pax.filter(
        (passageiro, index) => index !== action.index
      );
      return { ...state, pax: paxCopy };
    }
    case "RESERVAS_PASSAGEIOS_CHANGE": {
      var paxCopy = [...state.pax];
      var rowCopy = { ...paxCopy[action.index] };
      rowCopy[action.campoChange] = action.payload;
      paxCopy[action.index] = rowCopy;
      return { ...state, pax: paxCopy };
    }
    case "RESERVA_TAXA_CHANGE": {
      var copyTaxa = { ...state.taxa };
      var valor = 0;

      if (isNaN(action.payload)) {
        valor = Number(action.payload.replace(",", "."));
      } else {
        valor = action.payload;
      }

      copyTaxa.valor = valor;
      copyTaxa.id = action.id;

      return { ...state, taxa: copyTaxa };
    }

    case "RESERVA_TAXA_SET": {
      var copyTaxa = { ...state.taxa };
      var valor = 0;
      var total = 0;

      if (action.valor != null && action.valor !== "") {
        valor = isNaN(action.valor)
          ? Number(String(action.valor).replace(",", "."))
          : action.valor;
      }

      if (isNaN(action.total)) {
        total = Number(String(action.total).replace(",", "."));
      } else {
        total = action.total;
      }

      if (action.cobranca != null && !isNaN(action.cobranca)) {
        copyTaxa.cobranca = Number(action.cobranca);
      } else {
        const pct = action.percentual != null ? Number(action.percentual) : Number(valor);
        copyTaxa.cobranca = (total * pct) / 100;
      }

      copyTaxa.valor = valor;
      copyTaxa.percentual = action.percentual != null ? Number(action.percentual) : Number(valor);
      copyTaxa.id = action.payload;
      if (action.tipo) {
        copyTaxa.tipo = action.tipo;
      }

      return { ...state, taxa: copyTaxa };
    }

    case "RESERVA_TAXA_CALCULO": {
      var copyTaxa = { ...state.taxa };

      var valor = 0;

      if (isNaN(action.payload)) {
        valor = Number(String(action.payload).replace(",", "."));
      } else {
        valor = action.payload;
      }

      if (copyTaxa.id !== 3 && copyTaxa.id !== 7) {
        const novaCobranca = (valor * copyTaxa.valor) / 100;
        if (Math.abs((copyTaxa.cobranca || 0) - novaCobranca) < 0.0001) {
          return state;
        }
        copyTaxa.cobranca = novaCobranca;
        return { ...state, taxa: copyTaxa };
      }

      return state;
    }
    case "RESERVA_TAXA_CLEAR":
      return {
        ...state,
        taxa: { id: null, valor: 0, cobranca: 0 },
      };

    case "RESERVA_ORDEM_MAPA_EMBARQUE": {
      // let copyReservas = [...state.reservas]
      // let ordemMapa = []
      // let ordemHorario = []

      // ordemMapa = copyReservas
      //     .filter((reserva) => reserva.ordem_mapa_embarque !== null && reserva.ordem_mapa_embarque !== undefined)
      //     .sort((a, b) => a.ordem_mapa_embarque - b.ordem_mapa_embarque);

      // ordemHorario = copyReservas
      //     .filter((reserva) => reserva.ordem_mapa_embarque === null || reserva.ordem_mapa_embarque === undefined)
      //     .sort((a, b) => a.res_embarque_hora - b.res_embarque_hora);

      // let mergedReservas = [...ordemMapa, ...ordemHorario];

      return { ...state, reservasOrdenada: action.payload };
    }
    case "RESERVAS_ORDEM":
      return { ...state, reservasOrdenada: action.payload };

    case "HISTORICO_LOADING":
      return {
        ...state,
        loadingHistorico: true,
        historicos: [], // <— limpa aqui
      };

    case "HISTORICOS_FETCHED":
      return {
        ...state,
        historicos: action.payload,
        loadingHistorico: false,
      };

    case "RESERVA_CADASTRO_CLEAR":
      return {
        ...state,
        reserva: {
          parceiro: {},
          pagamentosAntecipado: [
            {
              tipoPagamento: null,
              formaPagamento: {
                label: "Selecione a forma de pagamento!",
                pag_credito: null,
                value: null,
              },
              local: "",
              parcela: { label: "Selecione o parcelamento!", value: null },
              valor: "",
              taxaCliente: null,
            },
          ],
          pagamentosEmbarque: [],
        },
        tarifa: null,
        pax: [
          {
            res_nome: "",
            idioma_select: { label: "Selecione um idioma!", value: "" },
            res_email: "",
            res_telefone: "",
          },
        ],
        taxa: {
          id: 0,
          valor: 0,
          cobranca: 0,
        },
        historicos: [],
      };

    default:
      return state;
  }
};
